import _ from "lodash";
import React from "react";
import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";
import { StandardTableSortablePropertyHeader } from "../../components/tables/StandardTable";
import useCompletedReviews from "./hooks/useCompletedReviews";
import CompletedReviewsTableRow from "./components/CompletedReviewsTableRow";

const CompletedReviewsSummary = () => {

    const {
        clear,
        loadMore,
        isRowLoaded,
        sort,
        sortTable,
        results,
        totalCount,
        error,
        isNextPageLoading,
        isError,
    } = useCompletedReviews();


    return (
        <React.Fragment>            
            <VirtualTable
                enableScrollTracking={false}
                row={CompletedReviewsTableRow}
                header={
                    <thead>
                        <tr>
                            <StandardTableSortablePropertyHeader
                                property="masterAccountName"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Client
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="reviewAdviser"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Adviser
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="reviewDate"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Review Date
                            </StandardTableSortablePropertyHeader><StandardTableSortablePropertyHeader
                                property="followUpSentDate"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Follow Up Sent
                            </StandardTableSortablePropertyHeader><StandardTableSortablePropertyHeader
                                property="previousFollowUpSentDate"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                            >
                                Previous Follow Up Sent
                            </StandardTableSortablePropertyHeader>
                            <StandardTableSortablePropertyHeader
                                property="reviewScore"
                                sort={sort}
                                sortTable={sortTable}
                                isSticky={true}
                                className="text-center"
                            >
                                Score   
                            </StandardTableSortablePropertyHeader>
                            <th></th>
                        </tr>
                    </thead>
                }
                footer={
                    <TableRecordCountDisplayFooter 
                        totalCount={totalCount}
                        isNewRecordsDisplayed={false}
                        newRecordsSinceCache={0}
                        reload={clear}
                    />
                }
                error={error}
                isItemLoaded={isRowLoaded}
                loadMoreItems={loadMore}
                itemSize={42}
                isLoading={isNextPageLoading}
                itemCount={totalCount}
                itemData={results}
            />
        </React.Fragment>
    );
};

export default CompletedReviewsSummary;
